import { AbstractControl, Validators } from '@angular/forms';
import { GenericAccountValidator } from './generic-account-validator';

export class PixAccountValidator extends GenericAccountValidator {
    protected static errors: any = {
        'es-AR': {
            bad_email: 'Clave incorrecta'
        },
        'en-US': {
            bad_email: 'Incorrect key'
        }
    };
    protected static label: any = {
        'es-AR': 'Clave ',
        'en-US': 'Account of '
    };
    protected static placeholder: any = {
        'es-AR': 'CPF / CNPJ / N° de teléfono / E-mail / Código QR',
        'en-US': 'CPF / CNPJ / Phone number / E-mail / Code QR'
    };
    public getLabelToAccountType(): string {
        return PixAccountValidator.label[PixAccountValidator.lang] ?? PixAccountValidator.label['es-AR'];
    }

    public getPlaceholderToAccountType(): string {
        return PixAccountValidator.placeholder[PixAccountValidator.lang] ?? PixAccountValidator.placeholder['es-AR'];
    }

    public accountValidate(control: AbstractControl): { [key: string]: any } | null {
        let error: any = GenericAccountValidator.errors[GenericAccountValidator.lang] ?? GenericAccountValidator.errors['es-AR'];
        if (Validators.required(control) !== null) {
            return { forbiddenName: error.bad_email };
        }

        return null;
    }
}
